module.exports = __webpack_public_path__ + "static/media/logoh.87cad23c.png";